import {Dispatch, FC, SetStateAction} from 'react';

import {Box, Dialog, styled, Typography, Drawer} from '@mui/material';
import {useTranslation} from 'react-i18next';

import Button from 'components/button/Button';

export const BasketConfirmDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '448px',
    padding: '16px 16px 24px 16px',
    borderRadius: '12px'
  }
}));

export const StyledBottomSheet = styled(Drawer)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0px 0px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    padding: '16px 16px 24px 16px'
  }
}));

export const BasketAcknowledgementButton = styled(Button)(() => ({
  margin: '0px 16px 0px 16px'
}));

export const DialogFooter = styled(Box)(({theme}) => ({
  '&': {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.fontSize - 4
    }
  }
}));

type FlexiBasketConfirmModalProps = {
  setShowConfirmModal: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  onConfirm: () => void;
  message: string;
  isReactNativeWebView: boolean;
};
export const FlexiBasketConfirmModal: FC<FlexiBasketConfirmModalProps> = ({
  onConfirm,
  setShowConfirmModal,
  open,
  message,
  isReactNativeWebView
}) => {
  const {t} = useTranslation();
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : BasketConfirmDialog;

  return (
    <ModalContainer open={open} anchor="bottom">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        maxWidth={isReactNativeWebView ? '100%' : '328px'}
        width="100%"
        gap="16px"
        marginBottom="32px"
      >
        <Box>
          <Typography fontWeight="bold" fontSize={20}>
            {t('flexiBasket.deleteProducts')}
          </Typography>
        </Box>
        <Box>
          <Typography fontSize={14} textAlign="center">
            {message}
          </Typography>
        </Box>
      </Box>
      <DialogFooter>
        <BasketAcknowledgementButton
          onClick={() => setShowConfirmModal(false)}
          fullWidth
          type="button"
          color="primary"
          variant="contained"
          shape="rounded"
        >
          {t('flexiBasket.keep')}
        </BasketAcknowledgementButton>
        <BasketAcknowledgementButton
          onClick={() => onConfirm()}
          fullWidth
          type="button"
          color="primary"
          variant="outlined"
          shape="rounded"
        >
          {t('flexiBasket.delete')}
        </BasketAcknowledgementButton>
      </DialogFooter>
    </ModalContainer>
  );
};

export default FlexiBasketConfirmModal;
